import React from 'react';
import PreLoginPage from './../core/PreLoginPage';

// ES6 class-style
class SA_LessonFeatures extends PreLoginPage {
  render() {
  	return(
	<div data-p-ga="" id="LessonFeatures">
		<div className="container">			
			<div className="row">
            <span>{this.rb("custom.label.txt.za1")}</span>
            <span>{this.rb("custom.label.txt.za2")}</span>
            <span>{this.rb("custom.label.txt.za3")}</span>
			    <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                    <img src={'/images/icons/Feature1.png'} alt="student listening to video lecture" />
                    <h3>{this.rb("za_lessonfeatures2.label.1")}</h3>
                    <p>{this.rb("za_lessonfeatures2.txt.1")}</p>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                    <img src={'/images/icons/ph2.png'} alt="Bite-sized quizzes" />
                    <h3>{this.rb("za_lessonfeatures2.label.2")}</h3>
                    <p>{this.rb("za_lessonfeatures2.txt.2")}</p>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                    <img src={'/images/icons/ph3.png'} alt=" Diagnostic test report" />
                    <h3>{this.rb("za_lessonfeatures2.label.3")}</h3>
                    <p>{this.rb("za_lessonfeatures2.txt.3")}</p>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                    <img src={'/images/icons/ph4.png'} alt="Granular report card" />
                    <h3>{this.rb("za_lessonfeatures2.label.4")}</h3>
                    <p>{this.rb("za_lessonfeatures2.txt.4")}</p>
                </div>
            </div>
		</div>
	</div>
  	);
  }
}

export default SA_LessonFeatures;


// WEBPACK FOOTER //
// ./src/views/za/za_LessonFeatures.js